/**
 * Maestro Ops sidebar. Paul (Oct 30 2026): only Control Center, Accounting (was Books), Admin, Devices, Diagnostics.
 * Hidden from the menu but still routed (nothing deleted): Letters /ops/letters, Engineering /ops/engineering,
 * Ship Monitor /ops/ship-monitor, Golden Behaviors /ops/golden-behaviors, Release Checklist /ops/release-checklist,
 * Fleet Diagnostics /admin/fleet-diagnostics.
 */
export const OPS_ADMIN_NAV = [
  { label: 'Control Center', path: '/ops/control-center' },
  { label: 'Accounting', path: '/ops/accounting' },
  { label: 'Admin', path: '/admin' },
  { label: 'Devices', path: '/admin/devices' },
  { label: 'Diagnostics', path: '/admin/diagnostics' },
];
